var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAnchorPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3724 15.0659C20.0001 15.4383 19.3964 15.4383 19.0241 15.0659L18.8139 14.8557L16.778 18.5359C16.4711 19.0907 15.9341 19.5011 15.3363 19.6379L5.01123 22L9.48095 17.5303C10.5778 18.1781 12.0142 18.0308 12.9567 17.0884C14.0737 15.9714 14.0737 14.1604 12.9567 13.0434C11.8397 11.9264 10.0286 11.9264 8.91162 13.0434C7.96921 13.9858 7.82191 15.4222 8.4697 16.5191L4 20.9887L6.36212 10.6638C6.49889 10.066 6.90932 9.52905 7.46411 9.22215L11.1443 7.18627L10.934 6.97592C10.5616 6.60359 10.5616 5.99992 10.934 5.62758L12.2823 4.27925C12.6547 3.90692 13.2583 3.90692 13.6307 4.27925L21.7207 12.3693C22.0931 12.7416 22.0931 13.3453 21.7207 13.7176L20.3724 15.0659Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.25C1.58579 4.25 1.25 4.58579 1.25 5C1.25 5.41421 1.58579 5.75 2 5.75H8C8.41421 5.75 8.75 5.41421 8.75 5C8.75 4.58579 8.41421 4.25 8 4.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAnchorPoint);
export default __webpack_public_path__ + "static/media/delete-anchor-point.c9b571eb13cbf1d37e7d00ca8c9cb8b4.svg";
export { ForwardRef as ReactComponent };